import IconTemplate from '@components/Icon';
import { rem } from 'polished';
import styled from 'styled-components';
import { DESKTOP_HEADER_HEIGHT, MOBILE_HEADER_HEIGHT } from '../../constants';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    margin-top: ${rem(MOBILE_HEADER_HEIGHT)};
    padding: 0 ${rem(20)};

    @media (min-width: ${breakpoints.sm}px) {
        margin-top: ${rem(DESKTOP_HEADER_HEIGHT)};
    }
`;

export const Date = styled.div`
    font-size: ${({ theme }) => theme.fontSizes.textBase};

    @media (min-width: ${breakpoints.sm}px) {
        padding: 0 ${rem(30)};
    }
`;

export const Title = styled.h1`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h3};
    font-family: ${({ theme }) => theme.fonts.fontSecondary};
    margin: ${rem(10)} 0 ${rem(30)} 0;

    @media (min-width: ${breakpoints.sm}px) {
        font-size: ${({ theme }) => theme.fontSizes.h2};
        padding: 0 ${rem(30)};
    }
`;

export const ImageSection = styled.div`
    display: flex;
    justify-content: center;
`;

export const Image = styled.img`
    border-radius: ${rem(12)};
    max-width: 100%;
    margin-bottom: ${rem(30)};
`;

export const Description = styled.div`
    font-size: ${({ theme }) => theme.fontSizes.h6};
    line-height: ${rem(30)};

    @media (min-width: ${breakpoints.sm}px) {
        padding: 0 ${rem(30)};
    }
`;
